import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { PackageResponse, WorkshopSystemEnum } from "src/domain/client";
import { FormService } from "src/app/services/form.service";
import { IconService } from "src/app/services/icon.service";
import { SectionTogglerComponent } from "../../layout/section-toggler/section-toggler.component";
import { TextAreaComponent } from "../../inputs/text-area/text-area.component";

@Component({
  selector: "app-specs-other-section",
  templateUrl: "./specs-other-section.component.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SectionTogglerComponent, TextAreaComponent, TranslateModule]
})
export class SpecsOtherSectionComponent {
  packages = input.required<PackageResponse[]>();
  otherPlaceholder = input.required<string>();

  WorkshopSystemEnum = WorkshopSystemEnum;

  constructor(
    public formService: FormService,
    public iconService: IconService
  ) {}
}
